import React, { useState } from 'react'
import { Drawer, notification, Row, Col, Button, Input } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import { updateFeesReceivedFxn } from '../actions/fcmtAction'

const CyprusFeeReceivedDrawer = (props) => {
  let { refreshApplication, studentId, applicationId, feeReceived = {} } = props
  let [visible, setVisible] = useState(false)
  let [amount, setAmount] = useState()
  let dispatch = useDispatch()
  const events = {
    showUpdateFeeDrawer: () => {
      setVisible(true)
    },
    hideUpdateFeeDrawer: () => {
      setVisible(false)
    },
    handleSubmit: async () => {
      if (!amount) {
        return notification.error({
          message: 'Please enter Fees'
        })
      }
      let obj = {
        amount: amount,
        studentId,
        applicationId
      }

      let resp = await dispatch(updateFeesReceivedFxn(obj))
      if (resp && resp.success) {
        setAmount()
        events.hideUpdateFeeDrawer()
        refreshApplication()
      }
    }
  }

  return (
    <div>
      {feeReceived && feeReceived.amount ?
        <div>
          Fees : {feeReceived.amount} <br />
          Rece. By : {feeReceived.name}
        </div> :
        <div>
          <a className={'btn btn-default roundNew sm'} onClick={events.showUpdateFeeDrawer}>
            Update Fees
          </a>
        </div>
      }

      {visible ?
        <Drawer
          width={'35%'}
          title={'Fee Received'}
          visible={visible}
          onClose={events.hideUpdateFeeDrawer}>
          <div className={'card unizportal'}>
            <Row gutter={16}>
              <Col span={24}>
                <InputBox title={'Amount'}>
                  <Input value={amount}
                         className='form-control'
                         placeholder={'Enter Fees'}
                         onChange={({ target }) => {
                           setAmount(target.value)
                         }} type={'number'} />
                </InputBox>
              </Col>
              <Col span={24}>
                <button type='submit' className={'btn'} onClick={events.handleSubmit}>
                  Submit
                </button>
              </Col>
            </Row>
          </div>
        </Drawer> : null}
    </div>
  )
}
export default CyprusFeeReceivedDrawer
